import { apiRequest } from '@/utils/api-request';
import type {
  CollectionChatPromptResponse,
  CollectionChatPromptError,
} from './get-collection-chat-system-prompt';

export const updateCollectionChatSystemPrompt = async (
  orgId: string,
  collectionId: string,
  prompt: string | null,
): Promise<CollectionChatPromptResponse | CollectionChatPromptError> => {
  const response = await apiRequest<CollectionChatPromptResponse>({
    url: `/collections/${orgId}/${collectionId}/chat/system-prompt`,
    method: 'PUT',
    body: { prompt },
    target: 'platform',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to save chat prompt.' };
  }

  if (!response?.data) {
    return { detail: 'Chat prompt response was empty.' };
  }

  return response.data;
};
